import { useEffect } from 'react';
import {
  NumberInputProps,
  useRecordContext,
  useSaveContext,
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import { useDebounce } from 'use-debounce';
import { Asset, Device } from '@x-guard/xgac-types/xgac';
import { GrayNumberInputWithUpperLabel } from './GrayNumberInputWithUpperLabel';

type Props = NumberInputProps & {
  isRequired?: boolean;
  needsSaving?: boolean;
};

export const GrayRaIntegerInputWithUpperLabel = (props: Props) => {

  const {
    source,
    needsSaving = false,
    ...numberInputProps
  } = props;

  const record = useRecordContext<Asset & { device: Device }>();
  const { save } = useSaveContext();

  const floorValue = useWatch({ name: source });
  const [debouncedFloor] = useDebounce(floorValue, 600);

  const recordId = record?._id;
  const savedFloor = record?.position?.properties?.address?.floor;

  useEffect(() => {

    if (!needsSaving || !save || !record?.position) {

      return;

    }

    if (debouncedFloor === undefined || debouncedFloor === null || debouncedFloor === '') {

      return;

    }

    const nextFloor = Number(debouncedFloor);
    if (Number.isNaN(nextFloor)) {

      return;

    }

    const currentSavedFloor = Number(savedFloor ?? 0);
    if (nextFloor === currentSavedFloor) {

      return;

    }

    save({
      ...record,
      position: {
        ...record.position,
        properties: {
          ...record.position.properties,
          address: {
            ...record.position.properties?.address,
            floor: nextFloor,
          },
        },
      },
    });

  }, [
    debouncedFloor,
    needsSaving,
    save,
    record,
    recordId,
    savedFloor,
  ]);

  return (
    <GrayNumberInputWithUpperLabel
      {...numberInputProps}
      source={source}
      step={numberInputProps.step ?? 1}
      size={numberInputProps.size ?? 'small'}
      fullWidth={numberInputProps.fullWidth ?? true}
      helperText={numberInputProps.helperText ?? false}
    />
  );

};
